enum PropertyTypes {
  TEXT = "text",
  NUMBER = "number",
  DROPDOWN = "dropdown",
  DATE = "date",
}

enum TargetTypes {
  ALL = "all",
  FIRST = "first",
  LAST = "last",
  SINGLE = "single",
  OTHER = "other",
}

export { PropertyTypes, TargetTypes }
